export default "__VITE_ASSET__DyG6Z77t__"